export default __webpack_public_path__ + "static/feature-dropspots-6bbcde372b3088a338a61d8540040bf4.png";